import { forwardRef } from 'react';
import MuiIconButton, { type IconButtonProps as MuiIconButtonProps } from '@mui/material/IconButton';

export type IconButtonProps = MuiIconButtonProps;

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ color = 'inherit', ...rest }, ref) => <MuiIconButton ref={ref} color={color} {...rest} />
);

IconButton.displayName = 'IconButton';
